module.exports = __webpack_public_path__ + "img/WPS图片4@2x.1ecbd931.png";